module.exports = __webpack_public_path__ + "static/media/mansi.98229e90.jpg";